export default __webpack_public_path__ + "static/media/goldenestateinvestors.7994d885.png";